export const invoicesConstants = {
 
    ADD_INVOICES_REQUEST: 'ADD_INVOICES_REQUEST',
    ADD_INVOICES_SUCCESS: 'ADD_INVOICES_SUCCESS',
    ADD_INVOICES_FAILURE: 'ADD_INVOICES_FAILURE',
    FETCH_STATE_REQUEST: 'FETCH_STATE_REQUEST',
    FETCH_STATE_SUCCESS: 'FETCH_STATE_SUCCESS',
    FETCH_STATE_FAILURE: 'FETCH_STATE_FAILURE',
    FETCH_INVOICES_REQUEST: 'FETCH_INVOICES_REQUEST',
    FETCH_INVOICES_SUCCESS: 'FETCH_INVOICES_SUCCESS',
    FETCH_INVOICES_FAILURE: 'FETCH_INVOICES_FAILURE',
      FETCH_ALLINVOICES_REQUEST: 'FETCH_ALLINVOICES_REQUEST',
    FETCH_ALLINVOICES_SUCCESS: 'FETCH_ALLINVOICES_SUCCESS',
    FETCH_ALLINVOICES_FAILURE: 'FETCH_ALLINVOICES_FAILURE',
    DELETE_INVOICES_REQUEST: 'DELETE_INVOICES_REQUEST',
    DELETE_INVOICES_SUCCESS: 'DELETE_INVOICES_SUCCESS',
    DELETE_INVOICES_FAILURE: 'DELETE_INVOICES_FAILURE',
    GET_INVOICES_DETAILS_REQUEST: 'GET_INVOICES_DETAILS_REQUEST',
    GET_INVOICES_DETAILS_SUCCESS: 'GET_INVOICES_DETAILS_SUCCESS',
    GET_INVOICES_DETAILS_FAILURE:'GET_INVOICES_DETAILS_FAILURE',
    UPDATE_INVOICES_REQUEST:'UPDATE_INVOICES_REQUEST',
    UPDATE_INVOICES_SUCCESS:'UPDATE_INVOICES_SUCCESS',
    UPDATE_INVOICES_FAILURE:'UPDATE_INVOICES_FAILURE',
    EXECUTE_INVOICES_REQUEST:'EXECUTE_INVOICES_REQUEST',
    EXECUTE_INVOICES_SUCCESS:'EXECUTE_INVOICES_SUCCESS',
    EXECUTE_INVOICES_FAILURE:'EXECUTE_INVOICES_FAILURE',
    FETCH_SITELIST_REQUEST:'FETCH_SITELIST_REQUEST',
    FETCH_SITELIST_SUCCESS:'FETCH_SITELIST_SUCCESS',
    FETCH_SITELIST_FAILURE:'FETCH_SITELIST_FAILURE',
    GET_SITE_DETAILS_REQUEST:'GET_SITE_DETAILS_REQUEST',
    GET_SITE_DETAILS_SUCCESS:'GET_SITE_DETAILS_SUCCESS',
    GET_SITE_DETAILS_FAILURE:'GET_SITE_DETAILS_FAILURE',
    POST_RESEND_REQUEST:'POST_RESEND_REQUEST',
    POST_RESEND_SUCCESS:'POST_RESEND_SUCCESS',
    POST_RESEND_FAILURE:'POST_RESEND_FAILURE'
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/invoicesConstants.js